/**
 * @file composer-strip-kind.ts
 * @description Какая полоса нужна полю ввода диалога (chat-window-design.md
 * §4, §5): порядок проверок — приоритет. Полосы «только чтение», «больше не
 * назначен» и «архив» встают ВМЕСТО поля ввода.
 */

import type { ConversationDetail } from "../../lib/api-chat";

export type ComposerStripKind = "readOnly" | "lost" | "archived" | "foreign" | "unassigned" | null;

/** Полосы, которые встают ВМЕСТО поля ввода. */
export const BLOCKING_STRIPS: ReadonlySet<ComposerStripKind> = new Set(["readOnly", "lost", "archived"]);

/** Какая полоса нужна диалогу; порядок строк — приоритет. */
export function composerStripKind(detail: ConversationDetail | null, meUserId: string, lost: boolean): ComposerStripKind {
  if (lost) return "lost";
  if (!detail) return null;
  if (detail.readOnly) return "readOnly";
  if (detail.archivedAt) return "archived";
  if (detail.assignedUserId && detail.assignedUserId !== meUserId) return "foreign";
  if (!detail.assignedUserId) return "unassigned";
  return null;
}

